import React from 'react';
import Util from '../../../../forecast-app/shared/util/util';
import styled from 'styled-components';
import {
	DeprecatedContentContainer as ContentContainer,
	FlexColumn,
	FlexRow,
	DeprecatedText as Text,
	deprecatedTheme as theme,
	Icon,
} from '@forecast-it/design-system';
import {FormattedHTMLMessage, useIntl} from 'react-intl';
import {NUMBER_TYPE} from '../../../../components/new-ui/project/project-budget-v3/util/BudgetUtils';
import {PROGRAM_BUDGET_TYPE} from '../../../../constants';
import ProjectUtil from '../../../shared/util/ProjectUtil';
import {ProgramHeaderTooltips as HeaderTooltips} from './ProgramHeaderTooltips';

export const getTotalCost = projects => {
	let totalCost = 0;
	projects.forEach(project => {
		totalCost +=
			project.node.financialNumbers.totalCostAtCompletion && ProjectUtil.isFixedPriceProject(project.node)
				? project.node.financialNumbers.totalCostAtCompletion
				: 0;
	});

	return totalCost;
};

const ProgramBudgetTypeProfitBox = ({program}) => {
	const {formatMessage} = useIntl();
	const intl = useIntl();

	const VerticalDivider = styled.div`
		border-left: 1px solid ${theme.colors.border.primary.default};
		height: 40px;
	`;

	const formatNumber = (value, numberType, currencySymbol, intl) => {
		switch (numberType) {
			case NUMBER_TYPE.MONEY:
				return Util.getFormattedNumberWithCurrency(currencySymbol, value, intl);
			case NUMBER_TYPE.PERCENTAGE:
				return Util.getFormattedPercentage(value, intl);
			default:
				break;
		}
		return value;
	};

	const totalCost = getTotalCost(program.projects.edges);

	return (
		<FlexRow alignItems={'flex-end'} gap={'xl'}>
			<ContentContainer width={'auto'} height={program.budgetType === PROGRAM_BUDGET_TYPE.CAPPED ? '250px' : '170px'}>
				<FlexColumn gap={'xl'}>
					<Text type={'heading'} variant={'m'} color={'primary'}>
						{<FormattedHTMLMessage id={'common.profit_margin'} />}
					</Text>
					<FlexRow justifyContent="left" alignItems="flex-start" gap={'xl'}>
						<FlexColumn gap={'s'}>
							<Text type={'label'} variant={'l'} color={'primary'}>
								{formatMessage({
									id: 'project_budget.actual_margin',
								})}
							</Text>
							<FlexRow gap={'m'}>
								<Text type={'heading'} variant={'s'} color={'primary'}>
									{formatNumber(
										program.projectsFinancialsToDate.recognitionActualProfitPercentage,
										NUMBER_TYPE.PERCENTAGE,
										null,
										intl
									)}
								</Text>
								<HeaderTooltips.ActualMarginTooltip>
									<Icon icon={'help'} size={'s'} />
								</HeaderTooltips.ActualMarginTooltip>
							</FlexRow>
						</FlexColumn>
						<VerticalDivider />
						<FlexColumn gap={'s'}>
							<FlexRow gap={'l'}>
								<div style={{width: '200px'}}>
									<Text type={'label'} variant={'l'} color={'primary'}>
										{formatMessage({
											id: 'common.projected_total_margin',
										})}
									</Text>
								</div>
							</FlexRow>
							<FlexRow gap={'m'}>
								<Text type={'heading'} variant={'s'} color={'primary'}>
									{formatNumber(
										program.budgetType === PROGRAM_BUDGET_TYPE.FIXED_PRICE
											? program.budgetValue > 0
												? (program.budgetValue - totalCost) / program.budgetValue
												: 0
											: program.projectsFinancialsTotals.recognitionProfitPercentage,
										NUMBER_TYPE.PERCENTAGE,
										null,
										intl
									)}
								</Text>
								<HeaderTooltips.ProjectedTotalMarginTooltip>
									<Icon icon={'help'} size={'s'} />
								</HeaderTooltips.ProjectedTotalMarginTooltip>
							</FlexRow>
						</FlexColumn>
					</FlexRow>
				</FlexColumn>
			</ContentContainer>
		</FlexRow>
	);
};

export default ProgramBudgetTypeProfitBox;
